<template>
  <v-card>
    <v-card-title>
      <span class="text-h5"> {{ $t('ITEM.ADD') }} {{ $t('LINKS.ITEM') }} </span>

      <v-spacer />

      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <documents-link-form
          v-model="form"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>

      <v-spacer />

      <v-btn depressed color="primary" :disabled="!valid" @click="create">
        {{ $t('BUTTON.CREATE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import DocumentsLinkForm from './forms/DocumentsLinkForm.vue';
import { DocumentsLinksService } from '@/services/documents-links.service';

export default {
  name: 'CreateDocumentsLink',

  components: {
    DocumentsLinkForm
  },

  mixins: [errors],

  data() {
    return {
      valid: true,
      form: {
        title: ''
      }
    };
  },

  methods: {
    cancel() {
      this.$emit('cancel');
    },

    create() {
      if (!this.$refs.form.validate()) {
        return;
      }

      DocumentsLinksService.create(this.form)
        .then(({ data }) => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$emit('created', data.data);
        })
        .catch(this.handleErrors);
    }
  }
};
</script>
